/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import Loader from "../../../component/loader";
import { connect } from "react-redux";
import HeaderNoAuth from "../../../component/header/headerNoAuth";
import actionTypes from "../../../store/actions";
import classes from "../apiPortal/apiPortal.module.css";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import classes2 from "../documentation/documentation.module.css";

class SDK extends Component {
  state = {
    loading: false,
  };

  componentDidMount() {}
  render() {
    return (
      <React.Fragment>
        <HeaderNoAuth />
        <main style={{ maxWidth: "initial" }}>
          <Grid container>
            <Grid
              item
              size={{
                xs: 2,
                md: 1,
              }}
            >
              <ul className={classes.leftNavigation}>
                <li>
                  {" "}
                  <Link to="/api-portal"> API Portal </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/api-read-only"> API Reference </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/registration"> Developer Registration </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link className={classes.selected} to="/sdk">
                    {" "}
                    API SDKs{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/api-ref"> Try Out API </Link>{" "}
                </li>
                {/*<li> <Link to='/internal-api'> Internal API </Link> </li>*/}
              </ul>
            </Grid>
            <Grid
              item
              size={{
                xs: 1,
                md: 1,
              }}
            ></Grid>
            <Grid
              item
              size={{
                xs: 9,
                md: 10,
              }}
            >
              <h1 className={classes2.heading}>
                Software Development Kits (SDKs)
              </h1>

              <p className={classes2.normalText}>
                Cumulator API is a REST API. So the choice of software libraries
                are of the Client (Builder). However, to make easier
                integrations, Cumulator API comes with client SDK for popular
                programming languages.
              </p>

              <p className={classes2.subHeading}> JavaScript SDK</p>

              <p className={classes2.definationText}>
                <ul>
                  <li>
                    <a href="./sdks/clients/javascript-client-generated.zip">
                      Download JavaScript SDK
                    </a>
                  </li>
                </ul>
              </p>

              <p className={classes2.subHeading}> Java SDK</p>

              <p className={classes2.definationText}>
                <ul>
                  <li>
                    <a href="./sdks/clients/java-client-generated.zip">
                      Download Java SDK
                    </a>
                  </li>
                </ul>
              </p>

              <p className={classes2.subHeading}> Python SDK</p>

              <p className={classes2.definationText}>
                <ul>
                  <li>
                    <a href="./sdks/clients/python-client-generated.zip">
                      Download Python SDK
                    </a>
                  </li>
                </ul>
              </p>

              <p className={classes2.subHeading}>Go SDK</p>

              <p className={classes2.definationText}>
                <ul>
                  <li>
                    <a href="./sdks/clients/go-client-generated.zip">
                      Download Go SDK
                    </a>
                  </li>
                </ul>
              </p>

              <p className={classes2.subHeading}>C Sharp (C#) SDK</p>

              <p className={classes2.definationText}>
                <ul>
                  <li>
                    <a href="./sdks/clients/csharp-client-generated.zip">
                      Download C Sharp SDK
                    </a>
                  </li>
                </ul>
              </p>

              <p className={classes2.subHeading}>Swift 5 SDK</p>

              <p className={classes2.definationText}>
                <ul>
                  <li>
                    <a href="./sdks/clients/swift5-client-generated.zip">
                      Download Swift 5 SDK
                    </a>
                  </li>
                </ul>
              </p>
              <p className={classes2.subHeading}> JaxRS CXF SDK</p>

              <p className={classes2.definationText}>
                <ul>
                  <li>
                    <a href="./sdks/clients/jaxrs-cxf-client-client-generated.zip">
                      Download JaxRS CXF SDK
                    </a>
                  </li>
                </ul>
              </p>
            </Grid>
          </Grid>
          <Loader loading={this.state.loading} />
        </main>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SDK);
